// Measured N-line prose with More/Less. A hidden, always-clamped probe of the
// same text and width is measured, so overflow is re-evaluated on content and
// width changes even while expanded. The toggle only appears on real overflow
// and stays available while expanded; `resetKey` collapses on record change.
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { T } from "../app/tokens.js";

const linkBtn = { border: 0, background: "transparent", padding: 0, color: T.blue, fontSize: T.fsXs, fontWeight: T.fwBold, cursor: "pointer", fontFamily: "inherit" };

export function ClampedProse({ text, lines = 3, resetKey, textStyle, textId, testId, probeTestId, toggleTestId }) {
  const probe = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflow, setOverflow] = useState(false);
  useEffect(() => { setExpanded(false); }, [resetKey]);
  useLayoutEffect(() => {
    const el = probe.current;
    if (!el) { setOverflow(false); return undefined; }
    const measure = () => setOverflow(el.scrollHeight - el.clientHeight > 1);
    measure();
    const ro = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
    ro?.observe(el);
    return () => ro?.disconnect();
  }, [text, lines]);
  const clamp = { display: "-webkit-box", WebkitLineClamp: lines, WebkitBoxOrient: "vertical", overflow: "hidden" };
  const open = expanded && overflow;
  return (
    <div style={{ position: "relative" }}>
      <p ref={probe} aria-hidden="true" data-testid={probeTestId}
        style={{ ...textStyle, ...clamp, position: "absolute", top: 0, left: 0, right: 0, visibility: "hidden", pointerEvents: "none" }}>{text}</p>
      <p id={textId} data-testid={testId} data-clamped={!open || undefined} style={{ ...textStyle, ...(open ? null : clamp) }}>{text}</p>
      {overflow && (
        <button type="button" data-testid={toggleTestId} aria-expanded={open} aria-controls={textId}
          onClick={() => setExpanded((v) => !v)} style={{ ...linkBtn, marginTop: 6 }}>
          {open ? "Less \u25B4" : "More \u25BE"}
        </button>
      )}
    </div>
  );
}
